var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalTimelineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_567",
    "data-name": "Rectangle 567",
    width: 16,
    height: 16,
    transform: "translate(848 26)",
    fill: "#ffa7a7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    "data-name": "Mask Group 2",
    transform: "translate(-848 -26)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Timeline",
    transform: "translate(848 26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M2,3A1,1,0,0,1,3,2H13a1,1,0,0,1,1,1V13a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1ZM13,3H3V13H13Z",
    fill: "#4c576c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M11,1a.5.5,0,0,1,.5.5v2a.5.5,0,0,1-1,0v-2A.5.5,0,0,1,11,1Z",
    fill: "#4c576c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M5,1a.5.5,0,0,1,.5.5v2a.5.5,0,0,1-1,0v-2A.5.5,0,0,1,5,1Z",
    fill: "#4c576c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M2,5.5A.5.5,0,0,1,2.5,5h11a.5.5,0,0,1,0,1H2.5A.5.5,0,0,1,2,5.5Z",
    fill: "#4c576c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M5.25,8a.5.5,0,0,1,.5-.5H7.5a.5.5,0,0,1,.39.812L7.337,9a1.5,1.5,0,1,1-1.9,2.305.5.5,0,0,1,.708-.706A.5.5,0,1,0,6.5,9.75a.5.5,0,0,1-.391-.812L6.46,8.5H5.75A.5.5,0,0,1,5.25,8Z",
    fill: "#4c576c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M10.224,7.553A.5.5,0,0,1,10.5,8v3.25a.5.5,0,0,1-1,0V9l-.2.15a.5.5,0,1,1-.6-.8l1-.75A.5.5,0,0,1,10.224,7.553Z",
    fill: "#4c576c",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalTimelineIcon);
export default __webpack_public_path__ + "static/media/modal-timeline-icon.7317ff59773583af24f1521cc0003772.svg";
export { ForwardRef as ReactComponent };